/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HorsePhoto } from '../models/HorsePhoto';
import { HttpFile } from '../http/http';

export class PaginatedHorsePhotos {
    'results': Array<HorsePhoto>;
    'next'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "results",
            "baseName": "results",
            "type": "Array<HorsePhoto>",
            "format": ""
        },
        {
            "name": "next",
            "baseName": "next",
            "type": "number",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return PaginatedHorsePhotos.attributeTypeMap;
    }

    public constructor() {
    }
}

